<template>
  <!-- 社教活动管理 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加章节
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>

          <el-table-column  prop="sequence" label="展示顺序" min-width="12%"></el-table-column>
          <el-table-column  prop="name" label="章节名称" min-width="40%" show-overflow-tooltip></el-table-column>

          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增章节': operation == 'edit' ? '编辑章节':'查看章节'" @close="onCancel" :close-on-click-modal="false"  :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入章节名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="sequence">
            <el-input v-model="addForm.sequence" :disabled="operation == 'view'" placeholder="请输入展示顺序" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="audio/*" :data="configData" :show-file-list="false" :on-change="uploadVideoProcess" :on-success="handleAudioSuccess" :before-upload="beforeAudioUpload">
              <audio v-if="audioUrl != '' && !audioFlag" v-bind:src="audioUrl" class="w-100" controls="controls">
                您的浏览器不支持视频播放
              </audio>

              <div class="tip" v-else-if="audioUrl == '' && !audioFlag">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传音频</div>
              </div>
              <el-progress v-if="audioFlag == true" type="circle" v-bind:percentage="audioUploadPercent" style="margin-top: 7px"></el-progress>

            </el-upload>
          </el-form-item>

          <el-form-item class="mb-30">
            <el-input v-model="audioSource" placeholder="上传音频自动获取讲解时长" disabled />
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: ["guideId"],
  data() {
    return {
      form: {
        name: '',
      },
      operation: 'add',
      addForm: {},
      rules: {
        name: [{ required: true, message: '章节名称不能为空', trigger: 'blur' }],
        sequence: [{ required: true, message: '章节展示顺序不能为空', trigger: 'blur' }],
      },

      configData: {
        tableName: 'collect'
      },
      audioFlag: false,
      audioUrl: "",
      audioUploadPercent: 0,
      audioSource: 0,
      listLoading: false,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  watch: {
    guideId(newV, oldV) {
      this.getData()
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getGuideChapterList({
        id: this.guideId,
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total

            this.$emit('updateChapter', this.tableData)

          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 重置查询
    resetForm(formName) {
      this.form = {
        name: '',
      }
      this.getTableList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getGuideChapterDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result

            this.audioSource = this.addForm.duration

            if (res.result.remarks) {
              this.audioUrl = res.result.remarks
            }

          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))

      this.audioSource = this.addForm.duration

      if (obj.remarks) {
        this.audioUrl = `/singleMuseum/attach/getFile?fileId=${obj.remarks}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delGuideChapter({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.audioUrl = ""
      this.audioSource = 0
      this.$refs["form"].clearValidate()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    //进度条
    uploadVideoProcess(file, fileList) {    //注意在data中添加对应的变量名
      const self = this
      if (file.status === 'ready') {
        this.audioFlag = true; // 显示进度条
        this.audioUploadPercent = 0;
        const interval = setInterval(() => {
          if (self.audioUploadPercent >= 99) {
            clearInterval(interval)
            return
          }
          self.audioUploadPercent += 1

        }, 20);
      }
      if (file.status === 'success') {
        setTimeout(() => {
          this.audioFlag = false; // 显示进度条
          this.audioUploadPercent = 100;
        }, 500)
      }
    },

    beforeAudioUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 500MB!',
          type: 'warning'
        })
        return
      }
    },

    handleAudioSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.audioUrl = res.result.attPath
        this.addForm.remarks = res.result.attId
        if (res.result.attSource) {
          let duration = res.result.attSource.split(':'), totalDuration = 0
          if (duration && duration.length > 0) {
            totalDuration = parseInt(duration[0]) * 60 + parseInt(duration[1])
          }
          this.audioSource = totalDuration
        }
      } else {
        this.$message.error(res.message)
      }
    },


    onSubmit() {
      const self = this
      this.addForm.roomId = this.guideId

      if (this.audioSource) {
        this.addForm.duration = this.audioSource
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addGuideChapter"
          if (this.addForm.id) {
            url = "updateGuideChapter"
          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '导览章节修改成功' : '新增导览章节成功',
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.audioUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 148px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>